import { render, staticRenderFns } from "./fl44-approvals-history-block.vue?vue&type=template&id=7d9d8b0f&"
import script from "./fl44-approvals-history-block.vue?vue&type=script&lang=js&"
export * from "./fl44-approvals-history-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d9d8b0f')) {
      api.createRecord('7d9d8b0f', component.options)
    } else {
      api.reload('7d9d8b0f', component.options)
    }
    module.hot.accept("./fl44-approvals-history-block.vue?vue&type=template&id=7d9d8b0f&", function () {
      api.rerender('7d9d8b0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl44/partials/fl44-approvals-history-block.vue"
export default component.exports